import modal from "@/components/common/modalManage";
import ConfirmComponent from "@/components/molecules/ConfirmComponent.vue";
import agent, { powerOfficeServiceBaseURL } from "@/services/agent";
import preLoader from "@/services/preLoader";
import toasterService from "@/services/toasterService";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import {
  CommandColumn,
  ColumnDirective as EColumn,
  ColumnsDirective as EColumns,
  GridComponent as EjsGrid,
  Group,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-vue-grids";
import { defineComponent } from "vue";
import { GridResponse } from "../../common/CommonInterfaces";
import { CompanyInfo, CompanyResponse, LookUpModel } from "./Company.model";
import { API_ENDPOINTS } from "./Constants";
import { loadLegalEntity } from "@/components/finance/common/CommonService";
import CardTitleComponent from '@/components/common/CardTitleComponent.vue';
import SearchComponent from '@/components/shared/SearchComponent.vue';
import '@/style.css'

export default defineComponent({
  components: {
    "ejs-grid": EjsGrid,
    "e-columns": EColumns,
    "e-column": EColumn,
    ConfirmComponent,
    DatePickerComponent,
    CardTitleComponent,
    SearchComponent,
  },
  provide: {
    grid: [Toolbar, Resize, Search, CommandColumn, Page, Sort, Group],
  },
  data() {
    return {
      gridData: [] as CompanyInfo[],
      form: {} as CompanyInfo,
      isUpdate: false,
      locale: "",
      searchOptions: {
        fields: ["name", "applicationKey", "clientKey", "subscriptionKey"],
        operator: "contains",
        ignoreCase: true,
      },
      toolbar: ["Search"],
      pageSettings: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 50,
        pageCount: 5,
      },

      forceSync: {
        date: null,
        format: "yyyy-MM-dd",
        today: new Date(),
        companyId: 0,
        type: "full",
      },
      selectedLegalEntityId: 0, 
      legalEntities: [] as LookUpModel[],
      existingLegalEntities: [] as LookUpModel[],
      showApplicationKey: false,
      showClientKey: false,
      showSubscriptionKey: false,
      searchText: "",
    };
  },
  computed: {
      legalEntityOptions() {
          if (!this.isUpdate) return this.legalEntities;
    
          const combined = [...this.legalEntities];

          const foundEntity = this.existingLegalEntities.find(
          e => e.id === Number(this.form.legalEntityId ?? 0)
          );

          if (foundEntity && !combined.some(e => e.id === foundEntity.id)) {
          combined.unshift(foundEntity); 
          }

          return combined;
      }
  },
  created() {
    agent.setBaseUrl(powerOfficeServiceBaseURL);
    this.gridLocalize();
  },
  mounted() {
    this.loadCompany();
  },

  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.gridLocalize();
      },
      immediate: true,
    },
  },

  methods: {
    async getLegalEntities() {
        const data = await loadLegalEntity();
        const existingIds = new Set(this.existingLegalEntities.map(e => e.id));

        this.legalEntities = data.filter(e => !existingIds.has(e.id));
        console.log(this.legalEntities);
        },
    async loadCompany() {
      const companyGrid: any = this.$refs.companyGrid;
      if (companyGrid) companyGrid.hideSpinner();
      const response = (await agent.get<GridResponse>(API_ENDPOINTS.GET)) || {};
      if (response.result) {
        this.gridData = response.result.result;
                       this.existingLegalEntities =  response.result.result?.map(item => ({
                        id: Number(item.legalEntityId ?? 0),
                        name: item.legalEntityName ?? ''
                        })).filter((entity, index, self) =>
                            index === self.findIndex(e => e.id === entity.id && e.name === entity.name)
                        ) ?? [];
                await this.getLegalEntities();
      }
    },

    async upsertCompany(event: any) {
      event.preventDefault();
      const apiEndpoint = this.isUpdate
        ? API_ENDPOINTS.PUT
        : API_ENDPOINTS.POST;
      const method = this.isUpdate
        ? agent.put<CompanyResponse>
        : agent.post<CompanyResponse>;
      const response = (await method(apiEndpoint, this.form)) || {};

      await this.loadCompany();
      this.resetPage();
      this.closeModal();

      if (response?.result?.isCommand) {
        toasterService.success(response.result.message);
      } else {
        toasterService.error(response.result.message);
      }
    },

    gridLocalize() {
      console.log(this.$i18n.locale);

      this.locale = "en-grid";
      if (this.$i18n.locale == "se") {
        setTimeout(() => {
          import(`@/assets/sv.json`).then((module) => {
            console.log(module);

            const localText = module.default;
            this.locale = "sv";
            setCulture("sv");
            L10n.load(localText);
          });
        });
      }
    },

    forceSyncByDate() {
      const params = {
        companyId: this.forceSync.companyId,
        forceSyncDate:
          this.forceSync.type === "full" ? null : this.forceSync.date,
      };
      preLoader.show();
      agent
        .post<any>(`v1/SyncLogMaster/ForceSync`, params)
        .then((response) => {
          if (response.result) {
            modal.Close("force-sync-modal");
            toasterService.success(response.result.message);
            preLoader.hide();
          }
        })
        .catch((e) => {
          preLoader.hide();
          modal.Close("force-sync-modal");
          console.warn(e);
        });
    },

    commandClick: function (args: { commandColumn: any; rowData: any }) {
      this.isUpdate = false;
      const app = this;
      if (args) {
        switch (args.commandColumn.type) {
          case "Edit":
            this.form = args.rowData;
            this.isUpdate = true;
            modal.Open("PageModal");
            break;
          case "ForceSync":
            this.forceSync.companyId = args.rowData.id;
            modal.Open("force-sync-modal");
            break;
          default:
            break;
        }
      }
    },

    openModal() {
      this.resetPage();
      modal.Open("PageModal");
    },

    closeModal() {
      this.resetPage();
      modal.Close("PageModal");
    },

    closeForceSyncModal() {
      modal.Close("force-sync-modal");
    },

    resetPage() {
      this.form = {
        id: 0,
        isActive: false,
      } as CompanyInfo;
      this.isUpdate = false;
      this.selectedLegalEntityId = 0;
    },
    onSearch(searchText: string) {
      const grid = (this.$refs.companyGrid as any)?.ej2Instances;
      if (grid) grid.search(searchText);
    },
    clearSearch() {
      this.searchText = '';
      const grid = (this.$refs.companyGrid as any)?.ej2Instances;
      if (grid) grid.search('');
    }
  },
});
